import { Search } from 'lucide-react';

interface ConversationSearchProps {
  value: string;
  onChange: (value: string) => void;
}

export const ConversationSearch = (props: ConversationSearchProps) => (
  <div className="border-t bg-background">
    <div className="relative p-2">
      <Search className="absolute left-5 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground pointer-events-none" />
      <input
        type="text"
        placeholder="Search"
        value={props.value}
        onChange={(event) => props.onChange(event.target.value)}
        className="w-full h-9 pl-9 pr-3 text-sm rounded-md border border-input bg-background ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
      />
    </div>
  </div>
);
